import { type FormEvent, useState } from 'react'
import type { ReactNode } from 'react'
import { Button } from './ui/Button'
import { inputClass } from './ui/FormField'

const DEV_PASSWORD = import.meta.env.VITE_DEV_PASSWORD as string | undefined

export default function DevGate({ children }: { children: ReactNode }) {
  const [unlocked, setUnlocked] = useState(() => {
    // Unsubscribing must always work, even before launch.
    if (!DEV_PASSWORD || window.location.pathname === '/unsubscribe') return true
    return sessionStorage.getItem('dev_unlocked') === '1'
  })
  const [input, setInput] = useState('')
  const [error, setError] = useState(false)

  if (unlocked) return <>{children}</>

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    if (input === DEV_PASSWORD) {
      sessionStorage.setItem('dev_unlocked', '1')
      setUnlocked(true)
    } else {
      setError(true)
      setInput('')
    }
  }

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center p-4">
      <form
        onSubmit={handleSubmit}
        className="bg-surface rounded-xl shadow-card p-10 w-full max-w-[380px]"
      >
        <div className="text-center font-bold text-[1.35rem] text-accent mb-1">Vet VPMS</div>
        <div className="text-center text-text-3 text-[0.9rem] mb-8">Enter access password</div>

        {error && (
          <div className="text-danger-text text-sm mb-4 text-center">Incorrect password</div>
        )}

        <input
          type="password"
          value={input}
          onChange={(e) => { setInput(e.target.value); setError(false) }}
          className={`${inputClass(error)} mb-4`}
          placeholder="Password"
          autoFocus
          autoComplete="current-password"
        />

        <Button type="submit" className="w-full">Enter</Button>
      </form>
    </div>
  )
}
